import { useCallback } from 'react';

import useModifiedFieldPendingChangeAuthors from './useModifiedFieldPendingChangeAuthors';

/**
 * A table's getCellPendingChangeAuthors for rows that are preview DTOs: who changed a highlighted cell,
 * from the change-history properties the backend lists behind the cell's fields (row.modifiedFieldDetails).
 * @returns {Function}
 */
const useTableCellPendingChangeAuthors = () => {
  const getModifiedFieldPendingChangeAuthors = useModifiedFieldPendingChangeAuthors();

  return useCallback(
    (row, fieldNames) => getModifiedFieldPendingChangeAuthors(row.modifiedFieldDetails, fieldNames),
    [getModifiedFieldPendingChangeAuthors],
  );
};

export default useTableCellPendingChangeAuthors;
